import Component from "@ember/component"
import { action, computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type EmberStore from "cc-frontend/services/ember-store"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import type Session from "cc-frontend/services/session"
import { includes } from "lodash-es"

export default class UnitRow extends Component {
  @service("ember-store") store!: EmberStore
  @service session!: Session
  @service lessonEditor!: LessonEditor

  // args
  modelsNeededForFirstEdit!: ModelsNeededForFirstEdit
  arrowUpDown!: Function
  canBeEditable!: boolean
  cardStack!: CardStack
  selectedUnitIds!: Array<string>
  unit!: Record<string, any>
  onUnitSelect!: Function
  isSelectable!: boolean
  hasFocus!: boolean
  planbook!: Planbook
  course!: Course
  rotationCalendar!: RotationCalendar

  @computed("selectedUnitIds.[]")
  get isSelected() {
    let selectedUnitIds = get(this, "selectedUnitIds")
    return includes(selectedUnitIds, this.cardStack.id)
  }

  @computed("canBeEditable", "cardStack.meta.permissions")
  get isReadOnly() {
    if (this.canBeEditable === false) return true
    if (this.cardStack) {
      return !includes(this.cardStack.meta.permissions, "can-edit-plan")
    } else {
      return false
    }
  }

  @action
  keyDown(event) {
    if (event.keyCode === 38) this.arrowUpDown("up")
    if (event.keyCode === 40) this.arrowUpDown("down")
  }

  @action
  onTitleIntermediateEdit(event) {
    let value = event.target.value
    if (this.session.isAuthenticated !== true) return
    this.lessonEditor.editTitle(this.modelsNeededForFirstEdit, this.cardStack.id, value, false)
  }

  @action
  onTitleEdited(event) {
    let value = event.target.value
    if (this.session.isAuthenticated !== true) return
    this.lessonEditor.finishEditingTitle(
      this.modelsNeededForFirstEdit,
      this.cardStack.id,
      value,
      this.cardStack.attributes.title || null
    )
  }

  @action
  unitSelect(cardStackId) {
    if (this.onUnitSelect) {
      this.onUnitSelect(cardStackId)
    }
  }
}
